import { ViewModel, View } from "binder"
import { SelectorBaseViewModel } from "src/common/reusableComponents/selectorBase/selectorBase-viewModel";
import { ServerConnection } from "src/server/serverConnection";

export class OPCSelectorViewModel extends SelectorBaseViewModel<OPC> {
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
    }

    protected async loadData(): Promise<OPC[]> {
        let result = await ServerConnection.callServer('/Complex/OpcServices/ListAllOpcs', {})
        return result.Opcs.map(x => {
            let o = new OPC(this);
            o.id = x.Id;
            o.title = `${x.Name} (${x.Code})`;
            return o;
        });
    }
}

export class OPC extends ViewModel {
    public getTypeId(): string { return ''; }
    public GetDefaultView(): View<ViewModel> { return null; }
    constructor(parent: ViewModel) {
        super(parent);
    }

    public set id(v: string) { this._id = v; } public get id(): string { return this._id; } private _id: string;
    public set title(v: string) { this._title = v; } public get title(): string { return this._title; } private _title: string;
}